<template>
<div class="chapter">
<div class="inner_page">
<div class="centerfull" id="_idParaDest-2">
<img alt="Helper Hounds. Spooky Helps Danny Tell the Truth. By Caryn Rivadeneira. Illustrated by Priscilla Alpaugh. Red Chair Press. Egremont, Massachusetts." src="image/titlepage.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HelperHounds_Bk6_Spooky-1.vue?9cfe7a78